import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'
import 'swiper/css/pagination'

const swiper = new Swiper('.swiper', {
	zoom: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	effect: 'creative',
	creativeEffect: {
		prev: {
			shadow: false,
			translate: ["-20%", 0, -1],
		},
		next: {
			shadow: false,
			translate: ["100%", 0, 0],
		},
	},
	on: {
		slideChange: swiper => {
			[...swiper.el.previousSibling.children].forEach(img => img.classList.remove('active'))
			swiper.el.previousSibling.children[swiper.activeIndex].classList.add('active')
		}
	}
})

window.addEventListener('click', e => {
	if (e.target.classList.contains('thumbnail-wrapper')) {
		const index = [...e.target.parentNode.children].indexOf(e.target)
		swiper.slideTo( index )
	}
})